// extracted by mini-css-extract-plugin
export default {"col":"formCol_col__Bqu53"};